export const convertToNativeNumerals = (number, language = "en") => {
  const numStr = number?.toString() || "";

  const numeralSystems = {
    en: ['0','1','2','3','4','5','6','7','8','9'],
    enhi: ['0','1','2','3','4','5','6','7','8','9'],

    hi: ['०','१','२','३','४','५','६','७','८','९'], // Hindi
    mr: ['०','१','२','३','४','५','६','७','८','९'], // Marathi

    ta: ['௦','௧','௨','௩','௪','௫','௬','௭','௮','௯'], // Tamil

  };

  const numerals = numeralSystems[language] || numeralSystems.en;

  return numStr
    .split("")
    .map(d => numerals[Number(d)] ?? d) // safe for "/" etc
    .join("");
};